/**
 * Desktop sidebar (HORO-10326) — fixed-left container that hosts the
 * shared MenuContent. Visible on viewports ≥ tablet breakpoint; hidden
 * on mobile (where the same MenuContent is rendered inside UserMenu as
 * a hamburger-triggered drawer).
 *
 * Two width states driven by `getSidebarCollapsed`:
 *   - expanded (190px, default) — full menu with labels
 *   - collapsed (70px) — icon-only stack per Figma 928:36258
 *
 * The shared top header keeps the Veda brand, so the sidebar starts
 * straight in on the menu content — no duplicate logo.
 */
import classNames from 'classnames';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSidebarCollapsed, toggleSidebarCollapsed } from '../../../store/slices/globalSlice';
import MenuContent from './MenuContent';
import styles from './styles.module.scss';

const Sidebar = () => {
    const dispatch = useDispatch();
    const collapsed = useSelector(getSidebarCollapsed);

    useEffect(() => {
        const sync = () => dispatch(toggleSidebarCollapsed(window.innerWidth < 1024));
        sync();
        window.addEventListener('resize', sync);
        return () => window.removeEventListener('resize', sync);
    }, [dispatch]);

    return (
        <aside className={classNames(styles.sidebar, { [styles.sidebarCollapsed]: collapsed })} aria-label="App navigation">
            <MenuContent collapsed={collapsed} />
        </aside>
    );
};

export default Sidebar;
